var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0604 5.11011L25.0976 5.11002V3.04662C25.0976 2.57421 24.7573 2.17285 24.2972 2.10295C24.2169 2.0907 22.3048 1.80863 20.0023 2.23412C17.4355 2.70844 15.3884 3.87816 14 5.64648C12.6115 3.87816 10.5644 2.70844 7.9976 2.23412C5.69501 1.80873 3.78291 2.0907 3.70268 2.10295C3.24262 2.17294 2.90228 2.57431 2.90228 3.04662V5.11002H0.939552C0.420753 5.11002 0 5.53733 0 6.06431V24.0457C0 24.3547 0.147259 24.6445 0.395298 24.8235C0.643338 25.0026 0.96133 25.0485 1.24859 24.9469C1.31911 24.9221 8.3599 22.4817 13.61 24.9138C13.8578 25.0286 14.1422 25.0286 14.39 24.9138C19.6254 22.4886 26.6813 24.9223 26.7514 24.9469C26.8521 24.9825 26.9564 25 27.0603 25C27.2529 25 27.4435 24.9399 27.6047 24.8236C27.8527 24.6446 28 24.3548 28 24.0458V6.0644C27.9999 5.53742 27.5792 5.11011 27.0604 5.11011ZM1.8792 22.769V7.0185H2.90228V19.7264C2.90228 20.0036 3.02173 20.2669 3.22829 20.4482C3.43484 20.6294 3.70956 20.7107 3.97957 20.6702C4.03142 20.6626 8.11318 20.0934 11.0953 22.1714C7.42186 21.5335 3.74529 22.2714 1.8792 22.769ZM13.0604 21.3108C11.7469 20.1056 10.0361 19.2906 7.9976 18.914C7.01657 18.7326 6.10643 18.6798 5.37862 18.6798C5.16254 18.6798 4.96249 18.6845 4.78157 18.6918V3.92287C6.58743 3.84015 10.9803 4.03624 13.0604 7.61739V21.3108ZM14.9395 7.61749C17.0122 4.05165 21.412 3.84666 23.2184 3.92527V18.6918C22.4281 18.6595 21.2745 18.6788 20.0023 18.914C17.9638 19.2906 16.253 20.1055 14.9395 21.3108V7.61749ZM16.9015 22.172C19.884 20.0928 23.9679 20.6625 24.0188 20.6701C24.2895 20.7114 24.564 20.6306 24.7712 20.4494C24.9785 20.2681 25.0976 20.0042 25.0976 19.7264V7.0186H26.1207V22.769C24.254 22.2712 20.576 21.533 16.9015 22.172Z",
    fill: "url(#paint0_linear_1742_1700)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1742_1700",
    x1: 37.7641,
    y1: 20.8054,
    x2: 28.7783,
    y2: 34.0269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookFill);
export default __webpack_public_path__ + "static/media/book-fill.45ee81981bfc9622d93fd49d3dd1febc.svg";
export { ForwardRef as ReactComponent };